import React from "react";
import { Translation } from "react-i18next";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import loadingActions from "../../flux/actions/LoadingActions";
import Landing from "./Landing";
import * as CONSTANTS from "../../utilities/Constants";
import sampleStatusStore from "../../flux/stores/sample/SampleStatusStore";
import dashboardActions from "../../flux/actions/dashboardActions";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { IActivityLogViewData, IDashboardInstrumentAvailabilityViewData, IDashboardSampleStatusViewData, ITopPropertiesAlarmDetailsViewData } from "../../models/dashboard/DashboardViewData";
import gradeListStore from "../../flux/stores/grade/ListStore";
import { IGradeViewData } from "../../models/grade/GradeViewData";
import gradeActions from "../../flux/actions/GradeActions";
import sourceActions from "../../flux/actions/SourceActions";
import sourceListStore from "../../flux/stores/source/ListStore";
import { ISourceViewData } from "../../models/source/SourceViewData";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { IStationViewData } from "../../models/station/StationViewData";
import stationListStore from "../../flux/stores/station/ListStore";
import stationActions from "../../flux/actions/StationActions";
import instrumentAvailabilityStore from "../../flux/stores/dashboard/instrumentAvailabilityStore";
import topPropertiesAlarmDetailsStore from "../../flux/stores/dashboard/topPropertiesAlarmDetailsStore";
import activityLogStore from "../../flux/stores/dashboard/activityLogStore";
import { ITrendPoint } from "@iom/trend";
import DateFormatting from "../../utilities/DateFormat";
import utility from "../shared/Utility";

interface IIndexState {
    sampleStatusData: IDashboardSampleStatusViewData;
    instrumentAvailabilityData: IDashboardInstrumentAvailabilityViewData;
    top5Alarms: ITopPropertiesAlarmDetailsViewData;
    activityLog: IActivityLogViewData,
    activityLogSeries: { measured: ITrendPoint[], unMeasured: ITrendPoint[] }
    gradeDropdownList: any[];
    selectedGrade: any[]
    sourceDropdownList: any[],
    selectedSource: any[],

    selectedStation: any[],
    stationDropdownList: any[]

    selectedDateRange: any[];
    selectFromDate: any;
    selectToDate: any;
}

export default class Index extends React.Component<{ location: any }, IIndexState> {
    private _mount = false;
    private _datetimeFormat = 'YYYY-MM-DD HH:mm:ss';
    private _gradeDropdownList: IGradeViewData[] = [];
    private _stationDropdownList: any[] = [];
    private _sourceList: any[] = [];
    private _ALL = "ALL";
    private _defaultDrpOption = [{ value: this._ALL, label: this._ALL }];

    constructor(props: { location: any }) {
        super(props);
        this.state = {
            sampleStatusData: undefined,
            instrumentAvailabilityData: undefined,
            top5Alarms: undefined,
            activityLog: undefined,
            activityLogSeries: { measured: [], unMeasured: [] },
            gradeDropdownList: [],
            selectedGrade: this._defaultDrpOption,
            sourceDropdownList: [],
            selectedSource: this._defaultDrpOption,
            stationDropdownList: [],
            selectedStation: this._defaultDrpOption,

            selectedDateRange: [CONSTANTS.DATE_RANGES[0]],
            selectFromDate: moment().subtract(1, 'd').format(this._datetimeFormat),
            selectToDate: moment().format(this._datetimeFormat),
        }
        this._mount = false;
    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {

        this._mount = true;
        loadingActions.setLoading(true);

        /// Remove all header options
        actionHeaderActions.common({
            moduleName: CONSTANTS.MODULE_SETTINGS,
            createData: {},
        }).then();

        //data loading to dropdowns
        gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this._gradeDropdownList = state.gradeDataList.result;
        });
        gradeActions.getAll(false, 1, CONSTANTS.PAGE_SIZE_ALL, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
            const gradeDropdownList: any[] = [];
            this._gradeDropdownList.forEach((element: IGradeViewData) => {
                gradeDropdownList.push({
                    label: element.name,
                    value: element.id
                });
            });
            loadingActions.setLoading(false);
            this.setState({ gradeDropdownList })
        }).catch(error => {
            loadingActions.setLoading(false);
        });

        sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                state.sourceDataList.result.forEach((source: ISourceViewData) => {
                    const data = {
                        label: source.name,
                        value: source.id
                    }
                    this._sourceList.push(data)
                })
            }
        });

        sourceActions.getAll(1, CONSTANTS.PAGE_SIZE_ALL, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
            this.setState({
                sourceDropdownList: this._sourceList
            });
        });

        sampleStatusStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this.setState({
                sampleStatusData: state.sampleData.data
            });
        });

        instrumentAvailabilityStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this.setState({
                instrumentAvailabilityData: state.instrumentData.data
            });
        });

        topPropertiesAlarmDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this.setState({
                top5Alarms: state.top5Alarms.data
            });
        });

        activityLogStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            this.setState({
                activityLog: state?.activityLog?.data
            }, () => {
                this.prepareSeriesForActivityLog();
            });
        });

        //Instrument Card
        stationListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._stationDropdownList = [];
                const data = state.stationDataList.result as IStationViewData[];
                data.forEach(element => {
                    const item = {
                        label: element.name,
                        value: element.id
                    }
                    this._stationDropdownList.push(item);
                });
            }
        });
        stationActions.getAll(1, CONSTANTS.PAGE_SIZE_ALL, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "").then(() => {
            this.setState({
                stationDropdownList: this._stationDropdownList
            });
        });
        this.getDashboardData();
    }

    private getSlotObject = () => {
        const duration = moment.duration(moment(this.state.selectToDate).diff(moment(this.state.selectFromDate)));
        const hours = duration.asHours();
        const days = duration.asDays();
        const months = duration.asMonths();
        let s: any = {
            slotInterval: 2,
            slot: "hours",
            openTime: this.state.selectFromDate,
            closeTime: this.state.selectToDate
        };

        if (hours > 24 && hours <= 48) {
            s.slotInterval = 4
        }
        if (hours > 48 && days <= 7) {
            s.slotInterval = 1
            s.slot = "days"
        }
        if (days > 7 && days <= 31) {
            s.slotInterval = 1
            s.slot = "weeks"
        }
        else if (months > 1) {
            s.slotInterval = 1
            s.slot = "months"
        }
        return s;
    }

    private prepareSeriesForActivityLog = () => {
        if (this.state?.activityLog) {
            let x: any = this.getSlotObject();
            let startTime = moment(x.openTime);
            let endTime = moment(x.closeTime).add(1, "minutes");
            let allTimes = [];
            while (startTime < endTime) {
                const range: any = { start: startTime.toString(), end: "" }
                startTime = moment(startTime).add(x.slotInterval, x.slot);
                range.end = startTime.toString();
                allTimes.push(range);
            }

            let measuredList: ITrendPoint[] = [];
            let unMeasuredList: ITrendPoint[] = [];
            allTimes.forEach(slot => {
                const measured: any = this.state.activityLog?.measuredSamples?.filter((x) => {
                    if((moment(utility.getLocalDateTime(x.sampleDate)).isSameOrAfter(moment(slot.start))) && (moment(utility.getLocalDateTime(x.sampleDate)).isBefore(moment(slot.end)))){
                        return x;
                    }
                });
                if (measured && measured.length > 0) {
                    measuredList.push({ xValue:  moment.utc(measured[0].sampleDate).toDate(), value: measured.length })
                }
                const unMeasured: any = this.state.activityLog?.unMeasuredSamples?.filter((x) => {
                    if((moment(utility.getLocalDateTime(x.sampleDate)).isSameOrAfter(moment(slot.start))) && (moment(utility.getLocalDateTime(x.sampleDate)).isBefore(moment(slot.end)))){
                        return x;
                    }
                });
                if (unMeasured && unMeasured.length > 0) {
                    unMeasuredList.push({ xValue: moment.utc(unMeasured[0].sampleDate).toDate(), value: unMeasured.length })
                }
            });
            this.setState({
                activityLogSeries: {
                    measured: measuredList,
                    unMeasured: unMeasuredList
                }
            })
        }
    }

    private getGetActivityLog = () => {
        loadingActions.setLoading(true);
        const request: any = {
            gradeIds: this.state.selectedGrade[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedGrade?.map(({ value }) => value) : [],
            sourceIDs: this.state.selectedSource[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedSource?.map(({ value }) => value) : [],
            stationIDs: this.state.selectedStation[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedStation?.map(({ value }) => value) : [],
            fromRange: moment.utc(this.state.selectFromDate).format("YYYY-MM-DDTHH:mm:ss"), // new Date(this.state.selectFromDate).toUTCString() 
            toRange: moment.utc(this.state.selectToDate).format("YYYY-MM-DDTHH:mm:ss"), // new Date(this.state.selectToDate).toUTCString()
        };
        dashboardActions.getGetActivityLog(request, uuidv4()).then(data => {
            loadingActions.setLoading(false);

        }).catch(error => {
            loadingActions.setLoading(false);
        });
    }

    private getTopPropertiesAlarmDetails = () => {
        loadingActions.setLoading(true);
        const request: any = {
            gradeIds: this.state.selectedGrade[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedGrade?.map(({ value }) => value) : [],
            sourceIDs: this.state.selectedSource[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedSource?.map(({ value }) => value) : [],
            stationIDs: this.state.selectedStation[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedStation?.map(({ value }) => value) : [],
            fromRange: moment.utc(this.state.selectFromDate).format("YYYY-MM-DDTHH:mm:ss"), // new Date(this.state.selectFromDate).toUTCString() 
            toRange: moment.utc(this.state.selectToDate).format("YYYY-MM-DDTHH:mm:ss"), // new Date(this.state.selectToDate).toUTCString()
        };
        dashboardActions.getTopPropertiesAlarmDetails(request, uuidv4()).then(data => {
            loadingActions.setLoading(false);

        }).catch(error => {
            loadingActions.setLoading(false);
        });
    }

    private getInstrumentAvailabilityData = () => {
        loadingActions.setLoading(true);
        const request: any = this.state.selectedStation[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedStation?.map(({ value }) => value) : [];
        dashboardActions.getInstrumentAvailability(request, uuidv4()).then(data => {
            loadingActions.setLoading(false);

        }).catch(error => {
            loadingActions.setLoading(false);
        });
    }


    private getSampleStatusData = () => {

        if (moment(this.state.selectFromDate) > moment(this.state.selectToDate)) {
            triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
        }
        else {
            loadingActions.setLoading(true);
            const sampleStatusReq: any = {
                gradeIds: this.state.selectedGrade[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedGrade?.map(({ value }) => value) : [],
                sourceIDs: this.state.selectedSource[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedSource?.map(({ value }) => value) : [],
                stationIDs: this.state.selectedStation[0]?.value !== this._defaultDrpOption[0]?.value ? this.state.selectedStation?.map(({ value }) => value) : [],
                fromRange: moment.utc(this.state.selectFromDate).format("YYYY-MM-DDTHH:mm:ss"), // new Date(this.state.selectFromDate).toUTCString() 
                toRange: moment.utc(this.state.selectToDate).format("YYYY-MM-DDTHH:mm:ss"), // new Date(this.state.selectToDate).toUTCString() 
            };
            dashboardActions.getSampleStatus(sampleStatusReq, uuidv4()).then(data => {
                loadingActions.setLoading(false);

            }).catch(error => {
                loadingActions.setLoading(false);
            });
        }
    }

    private gradeChangeHandler = (val: any) => {
        if (val.length === 0) {
            val = this._defaultDrpOption
        }
        if (val.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
            const inx = val.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
            if (inx !== -1) { val.splice(inx, 1); }
        }
        val.forEach((v: any) => {
            this.setState({
                selectedGrade: val
            }, () => {
                this.getDashboardData();
            })
        })
    }
    private stationChangeHandler = (val: any) => {
        if (val.length === 0) {
            val = this._defaultDrpOption
        }
        if (val.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
            const inx = val.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
            if (inx !== -1) { val.splice(inx, 1); }
        }
        val.forEach((v: any) => {
            this.setState({
                selectedStation: val
            }, () => {
                this.getDashboardData();
            })
        })
    }
    private sourceChangeHandler = (val: any) => {
        if (val.length === 0) {
            val = this._defaultDrpOption
        }
        if (val.find((x: { value: string; }) => x.value !== this._defaultDrpOption[0].value)) {
            const inx = val.findIndex((x: { value: string; }) => x.value === this._defaultDrpOption[0].value);
            if (inx !== -1) { val.splice(inx, 1); }
        }
        val.forEach((v: any) => {
            this.setState({
                selectedSource: val
            }, () => {
                this.getDashboardData();
            })
        })
    }
    private onDateRangeChange = (val: any) => {
        this.setState({
            selectedDateRange: val
        });
        let fromDate: any = "", toDate: any = "";
        let selectedDate = val[0]?.value;
        toDate = moment().format(this._datetimeFormat);
        switch (selectedDate) {
            case 1:
                fromDate = moment().subtract(1, 'd').format(this._datetimeFormat);
                break;
            case 2:
                fromDate = moment().subtract(7, 'd').format(this._datetimeFormat);
                break;
            case 3:
                fromDate = moment().subtract(30, 'd').format(this._datetimeFormat);
                break;
            case 4:
                fromDate = this.state.selectFromDate;
                toDate = this.state.selectToDate;
                break;
            default:
                fromDate = moment().subtract(1, 'd').format(this._datetimeFormat);
                break;
        }
        if (moment(fromDate) > moment(toDate)) {
            triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
        }
        else {
            this.setState({
                selectFromDate: fromDate,
                selectToDate: toDate
            }, () => {
                this.getDashboardData();
            })
        }
    }
    private setTrendCustomFromDate = (val: any) => {
        this.setState({ selectFromDate: moment(val).format(this._datetimeFormat) },
            () => { 
                this.getDashboardData();
             })
    }
    private setTrendCustomToDate = (val: any) => {
        this.setState({ selectToDate: moment(val).format(this._datetimeFormat) },
            () => {
                this.getDashboardData();
            })
    }
    private onRefresh = () => {
        this.onDateRangeChange(this.state.selectedDateRange);
    }

    private getDashboardData = () =>{
        this.getSampleStatusData();
        this.getInstrumentAvailabilityData();
        this.getTopPropertiesAlarmDetails();
        this.getGetActivityLog();
    }

    public render() {
        return (
            <Translation>
                {(t) => (
                    <div className="layout-margin">
                        <Landing
                            sampleStatusData={this.state.sampleStatusData}
                            instrumentAvailabilityData={this.state.instrumentAvailabilityData}
                            top5Alarms={this.state.top5Alarms}
                            activityLogSeries={this.state.activityLogSeries}
                            gradeDropdownList={this.state.gradeDropdownList}
                            selectedGrade={this.state.selectedGrade}
                            gradeChangeHandler={this.gradeChangeHandler}

                            selectedSource={this.state.selectedSource}
                            sourceDropdownList={this.state.sourceDropdownList}
                            sourceChangeHandler={this.sourceChangeHandler}

                            selectedStation={this.state.selectedStation}
                            stationDropdownList={this.state.stationDropdownList}
                            stationChangeHandler={this.stationChangeHandler}

                            selectedDateRange={this.state.selectedDateRange}
                            dateRangeChangeHandler={this.onDateRangeChange}
                            selectFromDate={this.state.selectFromDate}
                            selectToDate={this.state.selectToDate}
                            daterange={CONSTANTS.DATE_RANGES}
                            setTrendCustomFromDate={this.setTrendCustomFromDate}
                            setTrendCustomToDate={this.setTrendCustomToDate}
                            onRefresh={this.onRefresh}
                        />
                    </div>
                )}
            </Translation>
        );
    }
}
